module.exports = __webpack_public_path__ + "static/EWY_Jad_social-e4955adcd556f71746788d22c78a4c61.mp4";